import React from 'react'
import StyledAdminWrapper from './StyledAdminWrapper'

const URLShortener = React.lazy(() => import(/* webpackChunkName: 'admin-url-shortener' */'components_v2/Admin/UrlShortener'))

const StyledUrlShortener = ({ ...rest }) => {
  return (
    <StyledAdminWrapper>
      <URLShortener />
    </StyledAdminWrapper>
  )
}

export default StyledUrlShortener
